<template>
    <input
        :value="value"
        :type="type"
        :placeholder="placeholder"
        :disabled="disabled"
        :class="inputClasses"
        v-bind="$attrs"
        @input="$emit('input', $event.target.value)"
    />
</template>

<script>
export default {
    name: "CarbonInput",
    inheritAttrs: false,
    props: {
        value: {
            type: [String, Number],
            default: "",
        },
        /** text | email | number | password */
        type: {
            type: String,
            default: "text",
        },
        /** search: 검색창 스타일(고정 너비) */
        variant: {
            type: String,
            default: "default",
            validator: (v) => ["default", "search"].includes(v),
        },
        placeholder: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        customClass: {
            type: [String, Array],
            default: "",
        },
    },
    computed: {
        inputClasses() {
            const list = ["carbon-input"];
            list.push(`carbon-input--${this.variant}`);
            const custom = this.customClass;
            if (custom) {
                if (Array.isArray(custom)) list.push(...custom.filter(Boolean));
                else list.push(custom);
            }
            return list;
        },
    },
};
</script>

<style scoped>
.carbon-input {
    padding: 6px 10px;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
    font-size: 12px;
    background: #ffffff;
    color: #334155;
    width: 100%;
    box-sizing: border-box;
}

.carbon-input:focus {
    outline: none;
    border-color: #52b788;
}

.carbon-input:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.carbon-input--search {
    width: 180px;
    min-width: 100px;
}
</style>
